import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCalendarCircleMinus } from '@fortawesome/pro-light-svg-icons/faCalendarCircleMinus';
import { faCalendarCirclePlus } from '@fortawesome/pro-light-svg-icons/faCalendarCirclePlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { DataHubService } from 'src/core/services/datahub';
import { ViewBulkDrippingCreateSchema } from 'src/core/services/datahub/schemas/moduleList/viewBulkDrippingCreateSchema';
import { ViewBulkDrippingDeleteSchema } from 'src/core/services/datahub/schemas/moduleList/viewBulkDrippingDeleteSchema';
import useSelectedContent from 'src/modules/contentList/hooks/useSelectedContent';
import { Dropdown } from 'src/shared/components/dropdown';
import { Icon } from 'src/shared/components/icon';
import BulkActionButton from './bulkActionButton';
import * as styles from './bulkDrippingButton.module.css';
export function BulkDrippingButton() {
    const { t } = useTranslation();
    const { pages, modules, total } = useSelectedContent();
    function handleCreate() {
        window.dispatchEvent(new CustomEvent('app-content-admin:bulkactionsmenu:create-dripping', {
            detail: { pages, modules, total }
        }));
        DataHubService.sendEvent({
            schema: new ViewBulkDrippingCreateSchema({
                arrivedFrom: window.location.href,
                pages: pages.length,
                modules: modules.length
            })
        });
    }
    function handleDelete() {
        window.dispatchEvent(new CustomEvent('app-content-admin:bulkactionsmenu:delete-dripping', {
            detail: { pages, modules, total }
        }));
        DataHubService.sendEvent({
            schema: new ViewBulkDrippingDeleteSchema({
                arrivedFrom: window.location.href,
                pages: pages.length,
                modules: modules.length
            })
        });
    }
    return (_jsxs(Dropdown, { className: clsx(styles.dropdown, 'flex-[0_0_calc(50%-2px)] md:flex-initial'), position: "top", controls: _jsx(BulkActionButton, { icon: _jsx(Icon, { icon: faCalendarCirclePlus }), className: "w-full", children: t('module_list.bulk.schedule.action') }), children: [_jsx(Dropdown.Item, { title: t('module_list.bulk.schedule.new'), icon: _jsx(FontAwesomeIcon, { icon: faCalendarCirclePlus }), onClick: handleCreate }), _jsx(Dropdown.Item, { title: t('module_list.bulk.schedule.remove'), className: "text-danger-500", icon: _jsx(FontAwesomeIcon, { icon: faCalendarCircleMinus }), onClick: handleDelete })] }));
}
